import { Injectable } from '@angular/core';
import { Psa } from './psa';
import {LoginService} from '../../shared/services/login.service';
import {ApplicationServiceBase} from '../../shared/services/application-service-base';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {UploadfilesViewmodel} from '../../shared/viewmodels/uploadfiles-viewmodel';
import { ServiceBase } from '../../shared/services/service-base';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../app-environments/environment';
import { InLinePumps } from '../../shared/data-objects/inLine-pumps';
import { ApplicationBase } from '../../shared/data-objects/application-base';
import { UploadFileInformation } from '../../shared/data-objects/upload-file-information';
import { UploadFile2Information } from '../../shared/data-objects/upload-file2-information';

@Injectable()
export class PsaService  extends ApplicationServiceBase<Psa> {

  uploadfilesViewmodel: UploadfilesViewmodel;
  public onDevelopmentChange :BehaviorSubject<string>
  onApplicantSelection:BehaviorSubject<string>
  onApplicantAChange:BehaviorSubject<any>
  onApplicantConsultantChange:BehaviorSubject<any>
  onServiceSingleSelection:BehaviorSubject<string>
  onGeneralServiceSelection:BehaviorSubject<string>
  onInLinePumpSelection:BehaviorSubject<string>
  onBrownFielddevelopmentTypeSelection:BehaviorSubject<string>
  onGreenFielddevelopmentTypeSelection:BehaviorSubject<string>
  onRecycleSewerPumpSelection:BehaviorSubject<string>
  onRecycleWaterSelection:BehaviorSubject<boolean>
  inLinePumpsSelected:BehaviorSubject<any>
  totalLots:BehaviorSubject<any>
  noOfServiceChange:BehaviorSubject<any>

 onValidateInstallationNumber:BehaviorSubject<any>



  waterServiceDisplay:BehaviorSubject<any>
  generalServiceDisplay:BehaviorSubject<any>
  fireServiceDisplay:BehaviorSubject<any>

  fileList:any

  public static get submitUrl(): string {
    return ServiceBase.baseHref + '/api/submitPsaApplication';
  }

  static get addressUrl():string{
    return environment.addressUrl
  }

  private static get fileUploadUrl(): string {
    return ServiceBase.baseHref + '/api/fileupload/upload';
  }

  private static get updateFileInformationUrl(): string {
    return ServiceBase.baseHref + '/api/updatefile2upload';
  }

  private static getCookie(name: string): string {
    const ca: Array<string> = document.cookie.split(';');
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;

    for (let i: any = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
  clearFiles() {
    this.fileList = null;
  }

  addFile(fileList: any) {
     this.fileList = fileList    
  }


  constructor(protected http: HttpClient, protected loginService: LoginService) {
    super(http);
    const me = this;
    this.loginService.onLogout.subscribe(
      (next) => {
        me.initializeData();
      },
      (error) => {
        me.initializeData();
      }
    );
    this.initializeData();

    this.onDevelopmentChange= new BehaviorSubject('')
    this.onApplicantSelection= new BehaviorSubject('')
    this.onApplicantAChange= new BehaviorSubject(null)
   this.onApplicantConsultantChange= new BehaviorSubject(null)
    this.onServiceSingleSelection= new BehaviorSubject('')
    this.onGeneralServiceSelection = new BehaviorSubject('')
    this.onInLinePumpSelection= new BehaviorSubject('')
    this.onBrownFielddevelopmentTypeSelection= new BehaviorSubject('')
    this.onRecycleSewerPumpSelection = new BehaviorSubject('')
    this.onRecycleWaterSelection= new BehaviorSubject(null)
   this.onGreenFielddevelopmentTypeSelection= new BehaviorSubject('') 
   this.inLinePumpsSelected= new BehaviorSubject(null)
   this.totalLots= new BehaviorSubject(null)
   this.noOfServiceChange= new BehaviorSubject(null)

   this.onValidateInstallationNumber= new BehaviorSubject('')
  
 

   this.waterServiceDisplay= new BehaviorSubject(null)
  this.generalServiceDisplay =new BehaviorSubject(null)
  this.fireServiceDisplay=new BehaviorSubject(null)


  }

  initializeData(): void {
    super.initializeData();
    this.applicationData = new Psa();
    this.uploadfilesViewmodel = new UploadfilesViewmodel();
    this.clearFiles()
  }

  public submit(applicationDetails, token: string): Observable<string> {

  const {workRequestPsa,workrequestGreenField,...applicationData } = applicationDetails

    return super.submitImp(PsaService.submitUrl, applicationData, token);
  }

  getResult(addressString) {

    let headers = new HttpHeaders();
     headers = headers.set('authorization',environment.addressAuthKey);

    return this.http.get(PsaService.addressUrl+`?excludeAliases=false&stateTerritory=VIC&maxNumberOfResults=5&query=${addressString}`,{headers})
                .toPromise()
                .then((data) => 
                  { return data});
}

getAddressDetail(id)
{
         let headers = new HttpHeaders();
            headers = headers.set('authorization',environment.addressAuthKey)
                   .set('Accept-Crs','<https://www.opengis.net/def/crs/EPSG/0/4283>')

            return this.http.get(PsaService.addressUrl +`/${id}`,{headers})
             .toPromise()
             .then(data => 
               { return data });

}

uploadFile(token: string): Observable<string[]> {

  const allObservables: Observable<string>[] = [];

  for (let i = 0; i < this.fileList.length; i++) {
    let file: any = this.fileList[i];
    file.file.attachmentType = this.fileList[i].attachmentType;
    allObservables.push(Observable.create((subscriber) => {
        const uploadError = (e): void => {
          subscriber.next(null);
          subscriber.complete();
        };
        const uploadComplete = (e): void => {
          if (e.target.status !== 200) {
            uploadError(e);
            return;
          }
          const locations = JSON.parse(e.target.responseText);
          subscriber.next(locations.err_desc);
          subscriber.complete();
        };

        const formData: FormData = new FormData();
        formData.append('file', file.file, ServiceBase.sanitizeString(file.file.name));

        const xhr: XMLHttpRequest = new XMLHttpRequest();
        xhr.open('POST', PsaService.fileUploadUrl, true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + token);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('X-XSRF-TOKEN', PsaService.getCookie('XSRF-TOKEN'));
        xhr.addEventListener('load', uploadComplete, false);
        xhr.addEventListener('error', uploadError, false);
        // xhr.addEventListener('abort', uploadAbort, false);
        xhr.send(formData);
      }
    ));
  }

  return Observable.forkJoin(allObservables);
}

updateFileInformation(uploadFileInfo: UploadFile2Information, token: string): Observable<boolean> {
  const cleanuploadFileInfo = uploadFileInfo
  const header: HttpHeaders = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + token);

  return this.http.post<boolean>(PsaService.updateFileInformationUrl, JSON.stringify(cleanuploadFileInfo), {headers: header});
}

}



// WEBPACK FOOTER //
// ./src/app/create-application/psa-form/psa.service.ts